module.exports = __webpack_public_path__ + "img/star-filled.f8f62725.svg";